import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type CheckRequest = {
  clientId?: string | null;
  type?: string | null;
  enableMonitoring?: boolean | null;
  addressId?: string | null;
  documentId?: string | null;
  livePhotoId?: string | null;
  liveVideoId?: string | null;
  options?: object | null;
  clientConsent?: boolean | null;
  lastActionBy?: string | null;
};

export type ValidateRequest = {
  outcome: string;
  comment?: string | null;
  matchId?: string | null;
};

export type Check = {
  id: string;
  clientId: string;
  entityName: string;
  type: string;
  enableMonitoring?: boolean | null;
  addressId?: string | null;
  documentId?: string | null;
  livePhotoId?: string | null;
  liveVideoId?: string | null;
  options?: object | null;
  clientConsent?: boolean | null;
  lastActionBy?: string | null;
  status: string;
  result?: string | null;
};

export class Checks extends Resource<CheckRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("checks", axiosInstance);
  }

  public async create(
    clientId: string,
    checkRequest: CheckRequest
  ): Promise<Check> {
    return this.request({
      method: Method.POST,
      body: { clientId, ...checkRequest }
    });
  }

  public async get(id: string): Promise<Check> {
    return this.request({ method: Method.GET, path: id });
  }

  public async update(id: string, checkRequest: CheckRequest): Promise<Check> {
    return this.request({ method: Method.POST, path: id, body: checkRequest });
  }

  public async validate(
    id: string,
    validateRequest: ValidateRequest
  ): Promise<ValidateRequest> {
    const path = `${id}/validate`;
    return super.validateCheck(path, validateRequest);
  }

  public async list(
    clientId: string,
    {
      page,
      pageSize
    }: {
      page?: number;
      pageSize?: number;
    } = {}
  ): Promise<Check[]> {
    const { items: checks } = await this.request({
      method: Method.GET,
      query: { clientId, page, pageSize }
    });

    return checks;
  }
}
